import localStorageKeys from '../../../utils/localStorageKeys'
import ForPaid from '../../core/forPaid'
import plans from '../../../data/plans.json'

const RenderedForPaid = ({forPaidText, isExceeded, className, isTextWithLimits = false}) => {
    const currentPlan = localStorage.getItem(localStorageKeys.PLAN)
    const noPlan = currentPlan === plans.free_v1.key || currentPlan === plans.free_v2.key

    if (currentPlan === plans.free_v2.key) {
        return
    }

    return (
        <>
            {isTextWithLimits ? (
                <ForPaid forPaidText={forPaidText} isExceeded={isExceeded} className={className || ''}/>
            ) : (
                !noPlan && (
                    <ForPaid forPaidText={forPaidText} isExceeded={false} className={className || ''}/>
                )
            )}
        </>
    )
}

export default RenderedForPaid
